export default "__VITE_ASSET__Vf7qL03g__"